













































import {
  Button, Modal, Icon, Spin,
} from 'ant-design-vue';
import {
  Component, Vue, Prop, Emit,
} from 'vue-property-decorator';

interface WhiteboardItem {
  id: string | number; // 图片主键
  lessonId: string | number; // 讲次id
  classId: string | number; // 课程id
  createTime: string; // 创建时间
  updateTime: string; // 更新时间
  deleted: number; // 删除状态
  insId: string | number; // 机构id
  screenshotUrl: string; // 图片地址
  pageIndex: number; // 页码
  imageName: string; // 图片名称
  userId: string | number; // 用户id
  shouldLoad: boolean; // 是否需要加载
  loaded: boolean; // 图片是否已加载
  downloading: boolean; // 图片是否正在下载
  showPhoto: boolean; // 是否显示照片
}

@Component({
  components: {
    AModal: Modal,
    AIcon: Icon,
    AButton: Button,
    ASpin: Spin,
  },
})
export default class BanshuDialog extends Vue {
  @Prop({ default: false }) readonly visible!: boolean;

  @Prop({ default: false }) readonly banshuLesson!: { lessonId: number; lessonName: string; classId: number; lessonNum: number };

  // 板书列表
  private whiteboardList: WhiteboardItem[] = [];

  private visibleCount = 20; // 初始显示数量

  private loadStep = 10; // 每次加载数量

  get visibleItems(): WhiteboardItem[] {
    return this.whiteboardList.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.whiteboardList.length;
  }

  @Emit('update:visible')
  private handleCancel() {
    return false;
  }

  // 初始化懒加载
  private initLazyLoad() {
    this.$nextTick(() => {
      if (this.visibleItems.length > 0) {
        this.loadInitialImages();
      }
    });
  }

  // 加载初始图片
  private loadInitialImages() {
    const initialCount = Math.min(this.visibleCount, this.visibleItems.length);
    for (let i = 0; i < initialCount; i += 1) {
      this.whiteboardList[i].shouldLoad = true;
    }
  }

  // 滚动处理 - 懒加载和无限滚动
  private handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const { scrollTop } = container;
    const { scrollHeight } = container;
    const { clientHeight } = container;

    // 懒加载图片
    this.lazyLoadImages(container);

    // 无限滚动 - 接近底部时加载更多
    if (scrollTop + clientHeight >= scrollHeight - 100 && this.hasMore) {
      this.loadMore();
    }
  }

  // 懒加载图片
  private lazyLoadImages(container: HTMLElement) {
    const items = container.querySelectorAll('.whiteboard-item');
    const containerRect = container.getBoundingClientRect();

    items.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect();
      const isVisible = itemRect.top < containerRect.bottom + 200 && itemRect.bottom > containerRect.top - 200;

      if (isVisible && index < this.whiteboardList.length) {
        this.whiteboardList[index].shouldLoad = true;
      }
    });
  }

  // 加载更多项目
  private loadMore() {
    const newCount = Math.min(this.visibleCount + this.loadStep, this.whiteboardList.length);
    this.visibleCount = newCount;
  }

  // 图片加载完成
  private onImageLoad(index: number) {
    if (index < this.whiteboardList.length) {
      this.whiteboardList[index].loaded = true;
    }
  }

  // 图片加载错误
  private onImageError(index: number) {
    if (index < this.whiteboardList.length) {
      this.whiteboardList[index].loaded = true;
      // 可以设置错误状态或默认图片
    }
  }

  // 下载图片
  private async downloadImage(item: WhiteboardItem) {
    try {
      item.downloading = true;
      // 构建文件名：讲次序号-讲次名称-图片名称
      const fileName = `${this.banshuLesson.lessonNum}-${this.banshuLesson.lessonName}-${item.imageName}.png`;
      // 获取图片数据
      const response = await fetch(item.screenshotUrl);
      const blob = await response.blob();

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      // 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 清理URL对象
      window.URL.revokeObjectURL(url);

      // 埋点 - 此组件拿不到$track，所以需要父组件
      this.$emit('clickTrack', {
        action: 'PRELESSONS_BANSHU_DOWNLOAD_CLICK',
        params: {
          id: item.id,
          name: item.imageName,
          pageIndex: item.pageIndex,
          lessonId: item.lessonId,
        },
      });
    } catch (error) {
      this.$message.error(`${this.banshuLesson.lessonName}${item.imageName} 下载失败`);
    } finally {
      item.downloading = false;
    }
  }

  private showPhoto = false;

  private mounted() {
    this.fetchList(); // 默认 showPhoto=false，所以默认拉板书
  }

  private async clickBanshu() {
    if (this.showPhoto === false) return;
    this.showPhoto = false;
    await this.fetchList();
  }

  private async clickPhoto() {
    if (this.showPhoto === true) return;
    this.showPhoto = true;
    await this.fetchList();
  }

  // 获取板书数据

  private async fetchList() {
    try {
      // 切换 tab 时重置懒加载/分页状态
      this.visibleCount = 20;
      this.whiteboardList = [];

      const expendObj = {
        shouldLoad: true,
        loaded: true,
        downloading: false,
      };

      const params = { lessonId: this.banshuLesson.lessonId, classId: this.banshuLesson.classId };

      // 关键：根据 showPhoto 选择接口
      const res = this.showPhoto ? await this.$service.bk.getPhotoList(params) : await this.$service.bk.getBanshuList(params);

      this.whiteboardList = (res || []).map((item: any, index: number) => ({
        ...item,
        ...expendObj,
        // 关键：把合照的 photoUrl 也映射到 screenshotUrl
        screenshotUrl: item.screenshotUrl || item.photoUrl,
        // 合照没名字就给个默认
        imageName: item.imageName || `合照${index + 1}`,
      }));

      this.initLazyLoad();
    } catch (e) {
      // 可按需提示
    }
  }
}
